import { initialState } from "reducers/EditorHome/State";
import { EditorHome } from "constants/Actions";
import { getFilteredRuleList } from "functions";
import { INITIAL_DRAWER_INFO } from "components/EditorHome/Constants";

const {
  GET_ALL_TEXT_DATA,
  GET_ALL_TEXT_DATA_SUCCESS,
  GET_ALL_TEXT_DATA_FAIL,

  GET_ALL_TEMPLATE_RULES,
  GET_ALL_TEMPLATE_RULES_SUCCESS,
  GET_ALL_TEMPLATE_RULES_FAIL,

  GET_DATA_ADAPTERS,
  GET_DATA_ADAPTERS_SUCCESS,
  GET_DATA_ADAPTERS_FAIL,

  SAVE_TEMPLATE_CATEGORY,
  SAVE_TEMPLATE_CATEGORY_SUCCESS,
  SAVE_TEMPLATE_CATEGORY_FAIL,

  HANDLE_ADD_CATEGORY_DRAWER,

  UPDATE_CATEGORY_DISPLAY_NAME,
  UPDATE_CATEGORY_DISPLAY_NAME_SUCCESS,
  UPDATE_CATEGORY_DISPLAY_NAME_FAIL,

  GET_CATEGORY_DETAILS,
  GET_CATEGORY_DETAILS_SUCCESS,
  GET_CATEGORY_DETAILS_FAIL,

  GET_ALL_SETTINGS,
  GET_ALL_SETTINGS_SUCCESS,
  GET_ALL_SETTINGS_FAIL,

  UPDATE_SETTINGS,

  ADD_REMOVE_FROM_MESSAGE_TEMPLATES,
  ADD_REMOVE_FROM_MESSAGE_TEMPLATES_SUCCESS,
  ADD_REMOVE_FROM_MESSAGE_TEMPLATES_FAIL,
} = EditorHome;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_ALL_TEMPLATE_RULES:
      return Object.assign({}, state, {
        templateRules: {
          data: {},
          isLoading: true,
        },
      });
    case GET_ALL_TEMPLATE_RULES_SUCCESS:
      return Object.assign({}, state, {
        templateRules: {
          data: getFilteredRuleList(payload.data),
          isLoading: false,
        },
      });
    case GET_ALL_TEMPLATE_RULES_FAIL:
      return Object.assign({}, state, {
        templateRules: {
          data: {},
          isLoading: false,
        },
      });
    case GET_ALL_TEXT_DATA:
      return Object.assign({}, state, {
        texts: {
          data: [],
          isLoading: true,
        },
      });
    case GET_ALL_TEXT_DATA_SUCCESS:
      return Object.assign({}, state, {
        texts: {
          data: payload?.data,
          isLoading: false,
        },
      });
    case GET_ALL_TEXT_DATA_FAIL:
      return Object.assign({}, state, {
        texts: {
          data: [],
          isLoading: false,
        },
      });
    case GET_DATA_ADAPTERS:
      return Object.assign({}, state, {
        dataAdapters: {
          ...state.dataAdapters,
          isLoading: true,
        },
      });
    case GET_DATA_ADAPTERS_SUCCESS:
      return Object.assign({}, state, {
        dataAdapters: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_DATA_ADAPTERS_FAIL:
      return Object.assign({}, state, {
        dataAdapters: {
          ...state.dataAdapters,
          isLoading: false,
        },
      });
    case SAVE_TEMPLATE_CATEGORY:
      return Object.assign({}, state, {
        isCategorySaving: true,
      });
    case SAVE_TEMPLATE_CATEGORY_SUCCESS:
      return Object.assign({}, state, {
        isCategorySaving: false,
        addCategoryDrawer: INITIAL_DRAWER_INFO,
        addCategoryInitial: initialState.addCategoryInitial,
      });
    case SAVE_TEMPLATE_CATEGORY_FAIL:
      return Object.assign({}, state, {
        isCategorySaving: false,
      });
    case HANDLE_ADD_CATEGORY_DRAWER:
      return Object.assign({}, state, {
        addCategoryDrawer: payload.data,
      });
    case UPDATE_CATEGORY_DISPLAY_NAME:
      return Object.assign({}, state, {
        isDisplayNameUpdating: true,
      });
    case UPDATE_CATEGORY_DISPLAY_NAME_SUCCESS:
      return Object.assign({}, state, {
        isDisplayNameUpdating: false,
      });
    case UPDATE_CATEGORY_DISPLAY_NAME_FAIL:
      return Object.assign({}, state, {
        isDisplayNameUpdating: false,
      });
    case GET_CATEGORY_DETAILS:
      return Object.assign({}, state, {
        catgoryDetails: {
          ...state.catgoryDetails,
          isLoading: true,
        },
      });
    case GET_CATEGORY_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        catgoryDetails: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_CATEGORY_DETAILS_FAIL:
      return Object.assign({}, state, {
        catgoryDetails: {
          ...state.catgoryDetails,
          isLoading: false,
        },
      });
    case GET_ALL_SETTINGS:
      return Object.assign({}, state, {
        settings: {
          data: [],
          isLoading: true,
        },
      });
    case GET_ALL_SETTINGS_SUCCESS:
      return Object.assign({}, state, {
        settings: {
          data: payload?.data,
          isLoading: false,
        },
      });
    case GET_ALL_SETTINGS_FAIL:
      return Object.assign({}, state, {
        settings: {
          data: [],
          isLoading: false,
        },
      });
    case UPDATE_SETTINGS:
      return Object.assign({}, state, {
        updatedSettings: {
          data: payload?.data,
          isLoading: true,
        },
      });
    case ADD_REMOVE_FROM_MESSAGE_TEMPLATES:
      return Object.assign({}, state, {
        messageTemplatesUpdate: {
          data: [],
          isLoading: true,
        },
      });
    case ADD_REMOVE_FROM_MESSAGE_TEMPLATES_SUCCESS:
      return Object.assign({}, state, {
        messageTemplatesUpdate: {
          data: payload?.data,
          isLoading: false,
        },
      });
    case ADD_REMOVE_FROM_MESSAGE_TEMPLATES_FAIL:
      return Object.assign({}, state, {
        messageTemplatesUpdate: {
          data: [],
          isLoading: false,
        },
      });
    default:
      return state;
  }
};
